// 一些常用配置

export const ERR_OK = 200;

export const OPER_CODE = 200;

export const RETRY_TIMES = 1;

export const RETRY_DELAY = 1000;

export const MSG = "SUCCESS";

export const NAME_SPACE = "service_retry";

export const BASE_URL = ()=>{
  let baseUrl = "";

  let curUrl = window.location.href;
  // console.log("process",process.env.NODE_ENV);
  let env = process.env.NODE_ENV;
  if(env == "development"){
    baseUrl = "";
  }
  else{
    baseUrl = "https://app.globalstringer.com";//正式
  }

  // if(/^http:\/\/localhost:8[0-9]{3}/.test(curUrl)){//接通本地测试环境
  //   baseUrl = "https://app.globalstringer.com";//本地开发
  // }
  // else if(/^http:\/\/192\.168\.\d{1,3}\.\d{1,3}/.test(curUrl)){//本地开发接通线上测试环境
  //   // baseUrl = "http://manage1.media.kqiulive.com"; //测试
  //   baseUrl = "https://app.globalstringer.com"; //正式
  // }
  // else{
  //   baseUrl = "https://app.globalstringer.com";//正式
  // }

  return baseUrl;
}
